// Add unique utils for Machine Center here. Consider putting all other utils into the rotec-components library

import { Observable, OperatorFunction, concat, combineLatest, of } from 'rxjs';

export function isTruthy<T>(point: T | null | undefined): point is T {
  return !!point;
}

export function startWith$<T, D>(startWith: Observable<D>): OperatorFunction<T, T | D> {
  return (source: Observable<T>) => concat(startWith, source);
}

export function withValue<T, D>(value: D): OperatorFunction<T, [T, D]> {
  return (source: Observable<T>) => combineLatest([source, of(value)]);
}

export const opModeToSIDMapping: Record<string, string> = {
  0: 'MC_OP_Automatic',
  1: 'MC_OP_Standalone-Operation',
  2: 'MC_OP_Manual',
  3: 'MC_OP_Error',
  4: 'MC_OP_Step-Mode',
  5: 'MC_OP_Setup',
  6: 'MC_OP_Disconnected',
  7: 'MC_OP_Undefined',
};
